import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";

function ClientSearch({
  setFiltrationData,
  setRows,
  setTotal,
  placeholder = "Search with Client ID",
  width = "463px",
}) {
  const [searchValue, setSearchValue] = useState(null);

  useEffect(() => {
    if (searchValue === null) return;
    const id = setTimeout(() => {
      setFiltrationData((filtrationData) => {
        return {
          ...filtrationData,
          search: searchValue,
        };
      });
      setRows?.([]);
      setTotal?.(0);
    }, 300);

    return () => clearTimeout(id);
  }, [searchValue, setFiltrationData, setRows]);

  return (
    <TextField
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      placeholder={placeholder}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#683C8C",
          },
          "&:hover fieldset": {
            borderColor: "#683C8C",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#683C8C",
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <SearchIcon sx={{ width: "24px", height: "24px", mr: "10px" }} />
        ),
        sx: {
          width,
          height: "45px",
          borderRadius: "4px",
        },
      }}
    />
  );
}

export default ClientSearch;
